import { render, staticRenderFns } from "./ForgotPasswordNew.vue?vue&type=template&id=d5b25252&"
import script from "./ForgotPasswordNew.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports